import { Component, Input } from '@angular/core';
import { DeviceSettingsService } from '../../library/device-settings.service';
import { ControlService } from '../../library/control.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'app-device-settings-modal',
  templateUrl: './device-settings-modal.component.html',
  styleUrls: ['./device-settings-modal.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings',
    },
  ],
})
export class DeviceSettingsModalComponent {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;
  @Input() controlService: ControlService | undefined;
}
